import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import 'vant/lib/index.css';
import Ditto from '@zeekr-f2e/zeekr-ditto'
import VConsole from 'vconsole';
import BrowserLogger from 'alife-logger'
process.env.NODE_ENV
if (process.env.NODE_ENV != 'production') {
  new VConsole()
}

  BrowserLogger.singleton({
    pid: process.env.VUE_APP_ARMS_PID,
    appType:"web",
    enableLinkTrace: true,
    sendResource: true,
    behavior: true,
    useFmp: true,
    sample: 10,
    release: '1.0.0',
    imgUrl:"https://arms-retcode.aliyuncs.com/r.png?",
    c1: 'h5-subscription-client'
  })

const app = createApp(App);
app.use(router);
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  document.title = to.meta.title || ''
  Ditto.changeWebViewTitle({
    text:	to.meta.title || '',
    textColor:	"#fff",
    textSize:	"16",
  })
  next()
})

// 设置 rem 函数
function setRem() {
  // 320 默认大小16px; 320px = 20rem ;每个元素px基础上/16
  let htmlWidth =
    document.documentElement.clientWidth || document.body.clientWidth;
  //得到html的Dom元素
  let htmlDom = document.getElementsByTagName("html")[0];
  //设置根元素字体大小
  htmlDom.style.fontSize = htmlWidth / 20 + "px";
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};
console.log('新流水线')
app.mount("#app");
export default app